// eslint-disable-next-line import/prefer-default-export
export const PAGE_DESCRIPTIONS = {
    canonical: 'Тут можно настроить canonical для страниц. Это позволяет указать поисковикам, какую из страниц считать главной среди своих копий.',
};
